module.exports = __webpack_public_path__ + "img/selected1-min.08432b74.png";